import { render, staticRenderFns } from "./OccurrenceForm.vue?vue&type=template&id=c2f2bb2a&"
import script from "./OccurrenceForm.vue?vue&type=script&lang=js&"
export * from "./OccurrenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports